import { render, staticRenderFns } from "./FormTextAreaInput.vue?vue&type=template&id=8e7a4e7a&"
import script from "./FormTextAreaInput.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports